import React from 'react'
import CardUI from '../../../widgets/layout/CardUI'
import FormSF from '../../../widgets/form/FormSF'
import URLUtils from '../../../util/URLUtils'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputSelectSF from '../../../widgets/form/InputSelectSF'
import InputTextAreaSF from '../../../widgets/form/InputTextAreaSF'
import InputCheckBoxUI from '../../../widgets/form/InputCheckBoxUI'

const LoanSanctionUI = ({context, loan,
  loanName, onLoanNameChange, loanNameError, setLoanNameError,
  sanctionedAmount, onSanctionedAmountChange, sanctionedAmountError, setSanctionedAmountError,
  sanctionedTenureMonths, onSanctionedTenureMonthsChange, sanctionedTenureMonthsError, setSanctionedTenureMonthsError,
  interestTenureMonths, onInterestTenureMonthsChange, interestTenureMonthsError, setInterestTenureMonthsError, showInterestTenureMonths,
  sanctionedInterestRate, onSanctionedInterestRateChange, sanctionedInterestRateError, setSanctionedInterestRateError,
  sanctionedAPR, onSanctionedAPRChange, sanctionedAPRError, setSanctionedAPRError,
  processingFee2F, onProcessingFee2FChange, processingFee2FError, setProcessingFee2FError,
  promoterFundF3, onPromoterFundF3Change, promoterFundF3Error, setPromoterFundF3Error,
  dsraPercent, onDsraPercentChange, dsraPercentError, setDsraPercentError,
  depositPercent, onDepositPercentChange, depositPercentError, setDepositPercentError,
  specialTerms, onSpecialTermsChange, specialTermsError, setSpecialTermsError,
  addendumFilename, onAddendumFilenameChange, addendumFilenameError, setAddendumFilenameError,
  generate, onGenerateChange, followUpLoan, onFollowUpLoanChange,
  // form
  onSubmit, submitted, successMsg, errorList, errorCode, setErrorList,
  }) =>
  <CardUI context={context}>
    <FormSF context={context} buttonLabel='Sanction'
      onSubmit={onSubmit} busy={submitted}
      successMsg={successMsg} errorList={errorList} errorCode={errorCode} setErrorList={setErrorList}
    >
      <InputTextSF type='text' name='s_name' required={true} maxLength={20}
        label='Loan name'
        value={loanName} onChange={onLoanNameChange}
        error={loanNameError} setError={setLoanNameError}
        autoFocus={true}
      />
      <InputTextSF type='text' name='s_amt' required={true} maxLength={12}
        label='Sanctioned amount (₹)'
        help={`Requested amount: ${loan.loanRequest.amountF2}, amount in term sheet: ${loan.termSheet.amountF2}`}
        value={sanctionedAmount} onChange={onSanctionedAmountChange}
        error={sanctionedAmountError} setError={setSanctionedAmountError}
      />
      <InputTextSF type='text' name='s_tnr' required={true} maxLength={3}
        label='Sanctioned tenure (months)'
        help={`Requested tenure: ${loan.loanRequest.tenureMonths} months, tenure in term sheet: ${loan.termSheet.tenureMonths}`}
        value={sanctionedTenureMonths} onChange={onSanctionedTenureMonthsChange}
        error={sanctionedTenureMonthsError} setError={setSanctionedTenureMonthsError}
      />
      {
        showInterestTenureMonths &&
        <InputTextSF type='text' name='s_tnr' required={true} maxLength={3}
          label='Interest only tenure (months)'
          value={interestTenureMonths} onChange={onInterestTenureMonthsChange}
          error={interestTenureMonthsError} setError={setInterestTenureMonthsError}
        />
      }
      <InputTextSF type='text' name='s_intr' required={true} maxLength={8}
        label='Interest rate p.a.'
        help={`Interest rate in term sheet: ${loan.termSheet.interestRate}`}
        value={sanctionedInterestRate} onChange={onSanctionedInterestRateChange}
        error={sanctionedInterestRateError} setError={setSanctionedInterestRateError}
      />
      <InputTextSF type='text' name='s_apr' required={true} maxLength={6}
        label='Annual percentage rate (APR)'
        value={sanctionedAPR} onChange={onSanctionedAPRChange}
        error={sanctionedAPRError} setError={setSanctionedAPRError}
      />
      <InputTextSF type='text' name='s_prfee' required={true} maxLength={6}
        label='Processing fee 2'
        value={processingFee2F} onChange={onProcessingFee2FChange}
        error={processingFee2FError} setError={setProcessingFee2FError}
      />
      <InputTextSF type='text' name='promo_fund' required={true} maxLength={10}
        label='Promoter fund (₹)'
        help={`Typically project cost - loan amount + processing fee + DSRA + Deposit`}
        value={promoterFundF3} onChange={onPromoterFundF3Change}
        error={promoterFundF3Error} setError={setPromoterFundF3Error}
      />
      <InputTextSF type='text' name='s_dsra' required={true} maxLength={6}
        label='DSRA percent'
        value={dsraPercent} onChange={onDsraPercentChange}
        error={dsraPercentError} setError={setDsraPercentError}
      />
      <InputTextSF type='text' name='s_deposit' required={true} maxLength={6}
        label='Deposit percent'
        value={depositPercent} onChange={onDepositPercentChange}
        error={depositPercentError} setError={setDepositPercentError}
      />
      {/*
      <InputTextAreaSF type='text' name='s_terms' maxLength={6}
        label='Special terms (optional)'
        value={specialTerms} onChange={onSpecialTermsChange}
        error={specialTermsError} setError={setSpecialTermsError}
        help='Special terms will be added to Sanction Letter for eSigning'
      />
      */}
      {
        loan.appFlavor !== 'small_loan' &&
        <InputTextSF type='text' name='s_addendum' maxLength={40}
          label='Addendum file name (optional)'
          value={addendumFilename} onChange={onAddendumFilenameChange}
          error={addendumFilenameError} setError={setAddendumFilenameError}
          help='PDF file must be placed in S3 bucket finapp-dev-leegality-pdf-templates, folder addendum'
        />
      }
      {
        loan.appFlavor !== 'small_loan' &&
        <InputCheckBoxUI label='Followup loan'
          onChange={onFollowUpLoanChange} checked={followUpLoan}
          name='followUpLoan' help='In followup loan, loan agreement and supplementary agreement are generated'
        />
      }
      {
        loan.appFlavor !== 'small_loan' &&
        <InputCheckBoxUI label='Generate sanction letter'
          onChange={onGenerateChange} checked={generate}
          name='generate' help='Creates Leegality document and checks for necessary tokens'
        />
      }
    </FormSF>
  </CardUI>

export default LoanSanctionUI
